export default {
  SMARTCHAT_HEADER_INITIAL_DATA:            'SMARTCHAT_HEADER_INITIAL_DATA',
  SMARTCHAT_HEADER_UPDATE_CURRENT_PROCESS:  'SMARTCHAT_HEADER_UPDATE_CURRENT_PROCESS',
  SMARTCHAT_HEADER_UPDATE_CURRENT_TAB:      'SMARTCHAT_HEADER_UPDATE_CURRENT_TAB',
  SMARTCHAT_HEADER_UPDATE_CATEGORIES_LIST:  'SMARTCHAT_HEADER_UPDATE_CATEGORIES_LIST',
  SMARTCHAT_HEADER_UPDATE_LABELS_LIST:      'SMARTCHAT_HEADER_UPDATE_LABELS_LIST',
  SMARTCHAT_HEADER_UPDATE_DEPLOY_LOADING:   'SMARTCHAT_HEADER_UPDATE_DEPLOY_LOADING',
  SMARTCHAT_HEADER_UPDATE_DEPLOY_ERROR:     'SMARTCHAT_HEADER_UPDATE_DEPLOY_ERROR',
  SMARTCHAT_HEADER_UPDATE_MODAL_LOADING:    'SMARTCHAT_HEADER_UPDATE_MODAL_LOADING',
  SMARTCHAT_HEADER_UPDATE_MODAL_ERROR:      'SMARTCHAT_HEADER_UPDATE_MODAL_ERROR',
  SMARTCHAT_HEADER_UPDATE_LOADING:          'SMARTCHAT_HEADER_UPDATE_LOADING',
  SMARTCHAT_HEADER_UPDATE_ERROR:            'SMARTCHAT_HEADER_UPDATE_ERROR'
}
